import React from 'react';
import { Box } from '@mui/material';
import { topbarTokens as t } from './tokens';
import logo from '../../images/logo.png';

export default function Logo() {
    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <Box component="img" src={logo} alt="" aria-hidden="true"
                 sx={{ width: 26, height: 26, display: 'block' }}/>
            <Box component="span" sx={{
                fontFamily: t.font.sans,
                fontSize: 16,
                fontWeight: 600,
                color: t.color.fg,
                letterSpacing: '-0.01em',
            }}>
                Talent<Box component="span" sx={{ color: t.color.primary }}>Sense</Box>
            </Box>
        </Box>
    );
}
